import axios, { AxiosRequestConfig } from "axios";

import getErrorDetails from "./helpers/getErrorDetails";
import { portalApi, TAGS } from "./rtkApi";

import type Country from "../models/Country";
import type { CountryCode } from "../models/CountryCode";

/**
 * @deprecated Do not use it in the new code base. Use `useGetCountriesQuery` from `countriesApi` instead.
 * @see useGetCountriesQuery
 */
export async function getProcessableCountries(
  options?: AxiosRequestConfig
): Promise<Country["id"][]> {
  try {
    const response = await axios.get<Country["id"][]>(
      `/banks/countries/processable`,
      options
    );

    const { data = [] } = response;

    return data;
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export type GetCustomersResponse = CountryCode[];

const extendedApi = portalApi.injectEndpoints({
  endpoints: (builder) => ({
    getCountries: builder.query<GetCustomersResponse, unknown>({
      query: () => ({
        url: "/banks/countries/processable",
      }),
      providesTags: [TAGS.COUNTRIES],
    }),
  }),
});

export const { useGetCountriesQuery } = extendedApi;
export { extendedApi as countriesApi };
